import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M30.4141 16.668L23.9974 5.66797L17.5807 16.668L5.66406 20.3346L13.9141 28.5846L11.1641 42.3346L23.9974 36.5452L36.8307 42.3346L34.0807 28.5846L42.3307 20.3346L30.4141 16.668Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }